/* Custom "Blej tani" button.
 * Hides Shopify's accelerated checkout (Apple Pay / Google Pay / Shop Pay) on the
 * product form and replaces it with a plain Buy-now button that adds the variant
 * to the cart and sends the customer straight to checkout.
 * Wallets stay enabled everywhere else (cart, checkout).
 */
(function () {
  var LABEL = 'Blej tani';
  var SELECTOR = '.shopify-payment-button';

  function injectStyle() {
    if (document.getElementById('custom-buy-now-style')) return;
    var s = document.createElement('style');
    s.id = 'custom-buy-now-style';
    s.textContent = SELECTOR + '{display:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function addUrl() {
    var base = (window.Eurus && window.Eurus.cart_add_url) || '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }

  function checkoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'checkout';
  }

  function makeButton(form, atc) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-custom-buy-now', '');
    btn.className = (atc.className || 'button button-solid w-full').replace(/button-outline/g, 'button-solid');
    btn.textContent = LABEL;
    btn.disabled = !!atc.disabled;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      fetch(addUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add-to-cart failed');
          return r.json();
        })
        .then(function () {
          window.location.href = checkoutUrl();
        })
        .catch(function () {
          btn.disabled = false;
        });
    });

    try {
      new MutationObserver(function () {
        btn.disabled = !!atc.disabled;
      }).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    } catch (e) {}

    return btn;
  }

  function process(root) {
    var wallets = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < wallets.length; i++) {
      var wallet = wallets[i];
      if (wallet.dataset.customBuyNow) continue;
      var form = wallet.closest('form[action*="/cart/add"]');
      if (!form) continue;
      var atc = form.querySelector('[name="add"]');
      if (!atc) continue;
      wallet.dataset.customBuyNow = '1';
      wallet.parentNode.insertBefore(makeButton(form, atc), wallet);
    }
  }

  function start() {
    injectStyle();
    process(document);
    try {
      new MutationObserver(function () {
        process(document);
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
